
import VueMultiSelect from 'vue-multiselect'
import debounce from '@/mixins/debounce'

export default {
    components: { VueMultiSelect },

    props: {
        // eslint-disable-next-line vue/require-default-prop
        value: null,
        options: {
            type: Array,
            default: () => [],
        },

        multiple: {
            type: Boolean,
            default: false,
        },

        taggable: {
            type: Boolean,
            default: false,
        },

        api: {
            type: String,
            default: '',
        },

        trackBy: {
            type: String,
            default: 'slug',
        },

        placeholder: {
            type: String,
            default: 'select',
        },

        searchable: Boolean,

        caretIcon: {
            type: String,
            default: 'plus',
        },

        family: {
            type: String,
            default: 'far',
        },
    },

    data() {
        return {
            searchOptions: [],
        }
    },

    computed: {
        hasClear() {
            return this.$listeners && this.$listeners.clear
        },

        computedOptions() {
            return this.api ? this.searchOptions : this.options
        },
    },

    mounted() {
        if (this.api) this.getOptions()
    },

    methods: {
        getList: debounce(function (search) {
            this.getOptions(search)
        }, 500),

        getOptions(search) {
            if (!search) return
            const separator = this.api.includes('?') ? '&' : '?'
            const searchParam = search ? `${separator}q=${search}` : ''
            this.$axios
                .$get(this.api + searchParam)
                .then((res) => {
                    this.searchOptions = res.data
                })
                .catch((e) => {
                    this.searchOptions = []
                })
        },
    },
}
